<template>
  <div class="banner">
    <h2>Ready for Dessert?</h2>
    <p style="margin-top: 10px">
      We got something that'll definitely satisfy your sweet tooth!
    </p>
    <router-link type="button" class="btn" to="/bakedgoods"
      >Check Out Our Pies</router-link
    >
  </div>
</template>

<script>
export default {
  name: "menuCTA",
};
</script>

<style scoped>
.banner {
  background-image: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),
    url("https://images.unsplash.com/photo-1616682876554-c843263a28a2?ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8dGFibGVjbG90aHxlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&w=1000&q=80");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  padding: 80px 40px;

  color: #ffffff;
  text-align: center;
  box-shadow: 0px 0px 20px 5px #0d0d0d;
}

p {
  margin-bottom: 10px;
  font-size: 20px;
}

.btn {
  padding: 10px 4%;
  margin-top: 30px;
  margin-bottom: 0;
  background: rgba(128, 0, 0, 0.9);
  border: 2px solid rgba(128, 0, 0, 0.9);
  color: #ffffff;
  box-shadow: none;
  text-transform: uppercase;
  transition-duration: 0.3s;
  transition: all 0.3s;
  border-radius: 5px;
}

.btn:hover {
  transform: scale(1.05);
  color: #ffffff;
}

@media screen and (max-width: 768px){
  .banner{
    background-size: cover;
    background-repeat: no-repeat;
    background-position: bottom bottom;
    padding: 80px 40px;
    margin: 30px 0 10px !important;
  }
  p {
    margin-bottom: 10px;
    font-size: 18px;
  }
  .btn {
    padding: 10px 25px;
  }
}
</style>
